import { render } from "./admin-user.vue?vue&type=template&id=b8301820&scoped=true&ts=true"
import script from "./admin-user.vue?vue&type=script&lang=ts"
export * from "./admin-user.vue?vue&type=script&lang=ts"

import "./admin-user.vue?vue&type=style&index=0&id=b8301820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8301820"]])

export default __exports__